<template>
<div class="metal">
  <div class="metal-text">Выберите металл</div>
  <div class="metal-box">
    <div
        class="metal-box-metal"
        :class="{selectStyleElement: selectedMetal.silver}"
        @click="clickMetal('silver')"
    >
      <img class="image" src="../../images/icons/silver.svg">
      <div
          class="metal-box-metal-text"
          :class="{selectedStyleElementText: selectedMetal.silver}"
      >
        Серебро
      </div>
    </div>
    <div
        class="metal-box-metal"
        :class="{selectStyleElement: selectedMetal.gold}"
        @click="clickMetal('gold')"
    >
      <img class="image" src="../../images/icons/gold.svg">
      <div
          class="metal-box-metal-text"
          :class="{selectedStyleElementText: selectedMetal.gold}"
      >
        Золото
      </div>
    </div>
  </div>
</div>
</template>

<script setup>
import {reactive} from "vue";

const selectedMetal = reactive({
  silver: true,
  gold: false,
})

const clickMetal = (type) => {
  for (const key in selectedMetal) {
    selectedMetal[key] = (key === type);
    inputRes.value = type
  }
}

import {defineEmits, ref, watch} from "vue";

const inputRes = ref('')
const emit = defineEmits(['update:modelValue'])
watch(inputRes, (newValue) => {
  emit('update:modelValue', newValue);
})
</script>

<style lang="scss" scoped>
.metal {
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
  &-text {
    color: white;
    margin-bottom: 10px;
   }
  &-box {
    display: flex;
    justify-content: space-around;
    width: 60vw;
    &-metal {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 3px 22px 3px 22px;
      background: rgb(0 0 0 / 33%);
      border-radius: 25px;
      transition: 0.3s ease;
      &-text {
        position: absolute;
        color: white;
        bottom: -30px;
        font-size: 16px;
      }
    }
  }
}
.image {
  height: 30px;
  width: 30px;
}
.selectStyleElement {
  background-color: rgb(219 219 219 / 53%) !important;
  transition: 0.3s ease;
}
.selectedStyleElementText {
  //border: 2px solid white;
  //border-radius: 35px;
  //padding: 5px;
  font-size: 18px;
  font-weight: 600;
}
</style>
